const Close = ({
  size,
  color,
  strokeWidth = "1.5px",
  strokeColor = "black",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.638 10.6091L9.68968 7.65201L9.07668 7.0372L8.46356 7.6519L6.68157 9.43851L6.07162 10.05L6.68168 10.6615L9.63425 13.6206L6.68168 16.5798L6.07162 17.1912L6.68157 17.8028L8.46356 19.5894L9.07668 20.2041L9.68968 19.5893L12.638 16.6322L15.5864 19.5893L16.1994 20.2041L16.8125 19.5894L18.5945 17.8028L19.2045 17.1912L18.5944 16.5798L15.6418 13.6206L18.5944 10.6615L19.2045 10.05L18.5945 9.43851L16.8125 7.6519L16.1994 7.03719L15.5864 7.65201L12.638 10.6091ZM12.638 25.3811C6.16287 25.3811 0.910234 20.1181 0.910234 13.6206C0.910234 7.12321 6.16287 1.86018 12.638 1.86018C19.1132 1.86018 24.3659 7.12321 24.3659 13.6206C24.3659 20.1181 19.1132 25.3811 12.638 25.3811Z"
        fill={color}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default Close;
